import {
    gridPageCountSelector,
    gridPageSelector,
    useGridApiContext,
    useGridRootProps,
    useGridSelector,
} from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function CustomPagination() {
    const { t } = useTranslation()
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    const rootProps = useGridRootProps();

    const downSm = useMediaQuery(theme => theme.breakpoints.down('sm'));

    return (
        <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} alignItems="center" flex={1} py={1}>
            <Typography sx={{ mx: 2 }}>{`${t("Count")} : ${rootProps?.rowCount ?? 0}`}</Typography>
            <Box flex={1}>
                <Box display="flex" justifyContent="center">
                    <Pagination
                        color="primary"
                        count={pageCount}
                        page={page + 1}
                      //  siblingCount={downSm ? 0 : 2}
                        onChange={(event, value) => apiRef.current.setPage(value - 1)}
                    />
                </Box>
            </Box>
        </Box>
    );
}
